import React from 'react'
import {Logo} from './Logo'
import {footerLinks, sectionHref} from './constants'

function FooterV2({homePath = '/'}) {
  return (
    <footer className="hlm-footer">
      <div className="hlm-container">
        <div className="hlm-footer-top">
          <div className="hlm-footer-brand">
            <Logo surface="footer" homePath={homePath} />
            <p className="hlm-footer-tagline">Win more listings and handle every step without switching tools.</p>
          </div>
          <div className="hlm-footer-cols">
            <div>
              <div className="hlm-footer-col-title">Company</div>
              <div className="hlm-footer-col-links">
                <a href={footerLinks.privacy}>Privacy policy</a>
                <a href={footerLinks.terms}>Terms of service</a>
              </div>
            </div>
            <div>
              <div className="hlm-footer-col-title">Product</div>
              <div className="hlm-footer-col-links">
                <a href={sectionHref(homePath, 'features')}>Features</a>
                <a href={sectionHref(homePath, 'pricing')}>Pricing</a>
                <a href={sectionHref(homePath, 'faq')}>FAQ</a>
              </div>
            </div>
            <div>
              <div className="hlm-footer-col-title">Help</div>
              <div className="hlm-footer-col-links">
                <a href={footerLinks.helpVideos} target="_blank" rel="noopener noreferrer">
                  Help videos
                </a>
                <a href={footerLinks.askQuestion}>Ask a question</a>
                <a href={footerLinks.feedback} target="_blank" rel="noopener noreferrer">
                  Give feedback
                </a>
              </div>
            </div>
          </div>
        </div>

        <p className="hlm-footer-a11y">
          <strong>Our commitment to accessibility:</strong> HomeLight Listing Management is committed to making our website
          accessible and user friendly to all. While we are constantly working to improve, we welcome your feedback and
          accommodation requests. If you are having difficulty navigating our website, or if you have any suggestions to
          improve accessibility, please <a href={footerLinks.accessibilityEmail}>email our team</a>.
        </p>

        <div className="hlm-footer-bottom">
          <span>© 2026 HomeLight, Inc. All rights reserved.</span>
          <div className="hlm-footer-social">
            <a href={footerLinks.social.facebook} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" />
              </svg>
            </a>
            <a href={footerLinks.social.x} aria-label="X" target="_blank" rel="noopener noreferrer">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a href={footerLinks.social.linkedin} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
            <a href={footerLinks.social.instagram} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" fillRule="evenodd" aria-hidden="true">
                <path d="M7 0h10a7 7 0 0 1 7 7v10a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V7a7 7 0 0 1 7-7zm0 2.2A4.8 4.8 0 0 0 2.2 7v10A4.8 4.8 0 0 0 7 21.8h10a4.8 4.8 0 0 0 4.8-4.8V7A4.8 4.8 0 0 0 17 2.2zm5 3.65a6.15 6.15 0 1 1 0 12.3 6.15 6.15 0 0 1 0-12.3zm0 2.2a3.95 3.95 0 1 0 0 7.9 3.95 3.95 0 0 0 0-7.9zm6.4-3.9a1.45 1.45 0 1 1 0 2.9 1.45 1.45 0 0 1 0-2.9z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FooterV2
